export default {
  "legend-show": {
    key: "show",
    model: true,
    label: "echarts-config-legend-config-show-label",
  },
  "legend-position": {
    key: ["top", "left"],
    model: "top-left",
    component: "pure-select",
    label: "echarts-config-legend-config-position-label",
    placeholder: "echarts-config-legend-config-position-placeholder",
    options: [
      {
        label: "top-left",
        value: "top-left",
      },
      {
        label: "top-center",
        value: "top-center",
      },
      {
        label: "top-right",
        value: "top-right",
      },
      {
        label: "bottom-left",
        value: "bottom-left",
      },
      {
        label: "bottom-center",
        value: "bottom-center",
      },
      {
        label: "bottom-right",
        value: "bottom-right",
      },
    ],
  },
  "legend-icon": {
    key: "icon",
    model: "circle",
    component: "pure-select",
    label: "echarts-config-legend-config-icon-label",
    placeholder: "echarts-config-legend-config-icon-placeholder",
    options: [
      {
        label: "circle",
        value: "circle",
      },
      {
        label: "rect",
        value: "rect",
      },
      {
        label: "roundRect",
        value: "roundRect",
      },
      {
        label: "triangle",
        value: "triangle",
      },
      {
        label: "arrow",
        value: "arrow",
      },
      {
        label: "none",
        value: "none",
      },
    ],
  },
  "legend-orient": {
    key: "orient",
    model: "horizontal",
    component: "pure-radio-slide",
    label: "echarts-config-legend-config-orient-label",
    selection: [
      {
        label: "horizontal",
        value: "horizontal",
      },
      {
        label: "vertical",
        value: "vertical",
      },
    ],
  },
};
